<script setup lang="ts">
import Typography from '@components/Typography.vue';

interface MenuItemProps {
  isActive?: boolean,
  isExpanded?: boolean,
  hasPin?: boolean,
}

withDefaults(defineProps<MenuItemProps>(), {
  isActive: false,
  isExpanded: false,
  hasPin: false,
});
</script>

<template>
  <div
    class="menu-item"
    :class="[
      { 'menu-item--active': isActive },
      'rounded-lg',
      'h-12',
      isExpanded ? 'w-full' : 'w-14',
      'px-4',
      'flex items-center gap-2',
      isExpanded ? 'justify-start' : 'justify-center',
      'select-none',
      'cursor-pointer',
    ]"
  >
    <div
      class="relative flex flex-shrink-0"
      :class=" { 'justify-center': isExpanded }"
    >
      <slot name="icon" />

      <span
        v-if="hasPin"
        class="menu-item__pin"
        :class="[
          'absolute top-0 right-0',
          'rounded-full',
          'w-3 h-3',
        ]"
      />
    </div>

    <Typography
      v-if="isExpanded"
      :variant="isActive ? 'body-small-bold' : 'body-small'"
      :class="[ 'grow', 'whitespace-nowrap' ]"
    >
      <slot name="text" />
    </Typography>
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;

.menu-item {
  &--active {
    background-color: $colorBlueLightest;
  }

  @media (hover: hover) {
    &:hover {
      background-color: $colorBlueLightest;
    }
  }

  &__pin {
    background-color: $colorRed;
    border: 1px solid $colorWhite;
  }
}
</style>
